import React, {useState, useEffect, useRef} from 'react';
import AsyncSelect from 'react-select/async';
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";

const GenericAsyncSelect = (props) => {
    const {
        loadOptions,
        onItemClick,
        onClose,
        placeholder = "Selecione uma opção...",
        value = null,
        dataTest = "async-select",
        customOptionComponent = null,
        style = {},
        maintainInputValue = false,
        onInputValueChange = null
    } = props;

    const [, setLoading] = useRecoilState(loadingAtom);
    const [selectedValue, setSelectedValue] = useState(value);
    const [inputValue, setInputValue] = useState('');
    const selectRef = useRef(null);

    // Update selectedValue when value prop changes (for prefilled data)
    useEffect(() => {
        if (value !== selectedValue) {
            setSelectedValue(value);
        }
    }, [value, selectedValue]);

    // Handle selection change
    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption);
        if (selectedOption && onItemClick) {
            onItemClick(selectedOption.value);
        }
        // Clear input value when an option is selected (unless maintainInputValue is true)
        if (!maintainInputValue) {
            setInputValue('');
        }
    };

    // Handle input change
    const handleInputChange = (newInputValue, { action }) => {
        if (action === 'input-change') {
            setInputValue(newInputValue);
            if (onInputValueChange) {
                onInputValueChange(newInputValue);
            }
        } else if (action === 'set-value') {
            setInputValue('');
        } else if (action === 'menu-close' && !maintainInputValue) {
            // Clear input value when menu closes (unless maintainInputValue is true)
            setInputValue('');
        }
    };

    // Handle key down for ESC key
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            setInputValue('');
            setSelectedValue(null);
            if (selectRef.current) {
                selectRef.current.blur();
            }
        }
    };

    // Custom styles for the AsyncSelect
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '33px',
            height: '33px',
            width: style.width || provided.width,
            border: state.isFocused ? '1px solid #2980b9' : '1px solid #3498db',
            borderRadius: '5px',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #2980b9'
            },
            alignItems: 'center'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
            color: state.isSelected ? 'white' : 'black',
            cursor: 'pointer',
            padding: '8px 12px'
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            width: style.menuWidth || style.width || provided.width
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#333'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c757d'
        }),
        indicatorsContainer: () => ({
            display: 'none'
        }),
        dropdownIndicator: () => ({
            display: 'none'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    };

    return (
        <div data-test={dataTest}>
            <AsyncSelect
                ref={selectRef}
                cacheOptions
                loadOptions={loadOptions}
                onChange={handleChange}
                onInputChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                value={selectedValue || value}
                inputValue={inputValue}
                styles={customStyles}
                noOptionsMessage={() => null}
                loadingMessage={() => "Carregando..."}
                isClearable
                isSearchable
                defaultMenuIsOpen={false}
                onMenuOpen={() => {
                }}
                onMenuClose={() => {
                }}
                onFocus={() => {
                }}
                components={customOptionComponent ? {
                    Option: customOptionComponent
                } : undefined}
            />
        </div>
    );
};

export default GenericAsyncSelect; 